var DfpAds;

DfpAds = window.DfpAds != null ? window.DfpAds : window.DfpAds = {};

DfpAds.init = function(arg, done) {
  var dfpHeader;
  dfpHeader = arg.dfpHeader;
  if (!dfpHeader) {
    return done();
  }
  return DealContentLoader.addOnLoadHandler(function() {
    Groupon.DFPAds || (Groupon.DFPAds = {});
    Groupon.DFPAds.showAds = function() {
      return $('.dfp-footer, .dfp-side-rail').map(function() {
        return this.id;
      }).each(function(i, id) {
        return googletag.cmd.push(function() {
          return googletag.display(id);
        });
      });
    };
    return done();
  });
};

module.exports = DfpAds;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9kb3VibGVjbGljay9mcm9udGVuZC9kZnBfYWRzLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2FrZXNoYXJpL25hcGlzdHJhbm8vYnVpbGQvMTQ5NTY2MDg5ODI0OS00Mzk2L3Byb2R1Y3Rpb24tMjAxNy4wNS4yNF8yMS4xOS9kZWFsL21vZHVsZXMvZG91YmxlY2xpY2svZnJvbnRlbmQvZGZwX2Fkcy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxNQUFBLDJCQUFTLE1BQU0sQ0FBQyxTQUFQLE1BQU0sQ0FBQyxTQUFVOztBQUUxQixNQUFNLENBQUMsSUFBUCxHQUFjLFNBQUMsR0FBRCxFQUFjLElBQWQ7QUFDWixNQUFBO0VBRGMsWUFBRDtFQUNiLElBQUEsQ0FBcUIsU0FBckI7QUFBQSxXQUFPLElBQUEsQ0FBQSxFQUFQOztTQUVBLGlCQUFpQixDQUFDLGdCQUFsQixDQUFtQyxTQUFBO0lBQ2pDLE9BQU8sQ0FBQyxXQUFSLE9BQU8sQ0FBQyxTQUFXO0lBRW5CLE9BQU8sQ0FBQyxNQUFNLENBQUMsT0FBZixHQUF5QixTQUFBO2FBQ3ZCLENBQUEsQ0FBRSw2QkFBRixDQUFnQyxDQUFDLEdBQWpDLENBQXFDLFNBQUE7ZUFDbkMsSUFBQyxDQUFBO01BRGtDLENBQXJDLENBRUMsQ0FBQyxJQUZGLENBRU8sU0FBQyxDQUFELEVBQUksRUFBSjtlQUNMLFNBQVMsQ0FBQyxHQUFHLENBQUMsSUFBZCxDQUFtQixTQUFBO2lCQUNqQixTQUFTLENBQUMsT0FBVixDQUFrQixFQUFsQjtRQURpQixDQUFuQjtNQURLLENBRlA7SUFEdUI7V0FPekIsSUFBQSxDQUFBO0VBVmlDLENBQW5DO0FBSFk7O0FBZ0JkLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
